import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Niente log diagnostici in produzione (possono contenere dati utente).
  // Solo console.error resta attivo.
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// PWA: registra il service worker minimale dopo il load per non bloccare il bootstrap.
// Esito registrazione: error solo in caso di fallimento (log/debug/info/warn sono no-op in production).
if ('serviceWorker' in navigator && environment.production) {
  const registerSW = () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' })
      .then(reg => {
        console.info('[SW] registered', { scope: reg.scope, active: !!reg.active });
      })
      .catch(err => {
        console.error('[SW] registration FAILED:', err && err.message ? err.message : err);
      });
  };
  if (document.readyState === 'complete') {
    registerSW();
  } else {
    window.addEventListener('load', registerSW);
  }
}


  // node vv16.16.0